import { axiosInstance } from './index';
import {
    CompanyExternalPaginatedListResponseType,
    CompanyListRequestType,
    CompanyListResponseType,
    CompanyProfileResponseType,
} from '../../types/company';

export const companyService = {
    async getList(params: CompanyListRequestType) {
        const { data } = await axiosInstance.get('company', {
            params,
        });
        return data as CompanyListResponseType;
    },

    async getCompanyExternalList(params: CompanyListRequestType) {
        const { data } = await axiosInstance.get('company/GetCompanyExternalPaginatedList', {
            params,
        });
        return data as CompanyExternalPaginatedListResponseType;
    },

    async getId(companyName: string, encryptedId: string) {
        const { data } = await axiosInstance.get(`Company/priv/${companyName}-${encryptedId}`);
        return data as CompanyProfileResponseType;
    },

    async getPrivId(encryptedId: string) {
        const { data } = await axiosInstance.get(`Company/priv/${encryptedId}`);
        return data as CompanyProfileResponseType;
    },

    async getPubId(companyName: string, encryptedId: string) {
        const { data } = await axiosInstance.get(`Company/pub/${companyName}-${encryptedId}`);
        return data as CompanyProfileResponseType;
    },

    async getCompPubId(encryptedId: string) {
        const { data } = await axiosInstance.get(`Company/pub/${encryptedId}`);
        return data as CompanyProfileResponseType;
    },

    async getProfile() {
        const { data } = await axiosInstance.get('Company/GetMyCompanyProfile');
        return data as CompanyProfileResponseType;
    },

    async update(data: FormData) {
        await axiosInstance.put(`Company/UpdateMyCompanyProfile`, data);
    },

    async uploadDocument(data: FormData) {
        await axiosInstance.put(`Company/UpdateCompanyVerification`, data);
    },

    async updateBanner(data: FormData) {
        await axiosInstance.put(`Company/UpdateCompanyProfileBannerImage`, data);
    },

    async deleteBanner() {
        await axiosInstance.put(`Company/DeleteCompanyProfileBannerImage`);
    },

    async updateAvatar(data: FormData) {
        await axiosInstance.put(`Company/UpdateCompanyAvatar`, data);
    },

    async deleteAvatar() {
        await axiosInstance.put(`Company/DeleteCompanyAvatar`);
    },
};
